import { ConfigObject } from '../types';
import { BaseEntity, DEFAULT_SCOPE_NAME, EntityState } from './types';

export const resolveScope = (scope?: string | null) =>
  typeof scope === 'string' ? scope : DEFAULT_SCOPE_NAME;

export const asActions = <T extends BaseEntity, A extends ConfigObject<EntityState<T>>>(
  defaultActions: A,
): A => defaultActions;

export const resolveReferenceKey = (refIdKey: string) => refIdKey.replace('Id', '');

export const mapReferences = <T extends BaseEntity>(
  references: Partial<{ [k in keyof T]: T[k] }>,
  entity: T,
) => {
  Object.entries(references).map(([referenceIdKey, referenceEntityState]) => {
    const refId = entity[<keyof T>referenceIdKey];
    const referenceEntityValue = refId ? referenceEntityState.entityMap[refId] : null;
    const referenceEntityNewKey = resolveReferenceKey(referenceIdKey);
    entity[<keyof T>referenceEntityNewKey] = referenceEntityValue;
  });

  return entity;
};
